import React from 'react';
import { motion } from 'framer-motion';
import { FileSignatureIcon, ListChecksIcon, MessageSquareOffIcon, BoxIcon } from 'lucide-react';
interface Bono {
  title: string;
  desc: string;
  Icon: BoxIcon;
}
export function Bonos() {
  const bonos: Bono[] = [{
    title: 'B1 — Plantilla de consentimiento informado editable',
    desc: '5 modelos listos para imprimir o compartir por WhatsApp: cirugía, anestesia, internación, procedimientos diagnósticos y eutanasia.',
    Icon: FileSignatureIcon
  }, {
    title: 'B2 — Checklist de la consulta ideal',
    desc: 'Los 12 puntos que no podés saltarte en ninguna consulta para salir sin malentendidos, sin reclamos y con el propietario conforme.',
    Icon: ListChecksIcon
  }, {
    title: 'B3 — Guía de frases que nunca más vas a decir',
    desc: 'Las 10 frases que generan conflicto sin que te des cuenta — y qué decir en cambio. Para pegar en la pared de la consulta.',
    Icon: MessageSquareOffIcon
  }];
  return <section className="bg-white py-10 sm:py-16 px-5" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-green mb-2 sm:mb-3" data-id="element-21">
          Incluidos gratis
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-navy mb-2 sm:mb-3 leading-tight" data-id="element-22">
          3 Bonos de Alto Valor Clínico
        </h2>
        <p className="text-center text-gray text-sm sm:text-lg mb-8 sm:mb-12" data-id="element-23">
          Sin costo extra — incluidos en todas las ofertas
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 mb-8 sm:mb-9" data-id="element-24">
          {bonos.map((bono, i) => {
          const {
            Icon
          } = bono;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1,
            duration: 0.4
          }} whileHover={{
            y: -2
          }} whileTap={{
            scale: 0.98
          }} className="border-2 border-dashed border-gold rounded-2xl p-4 sm:p-6 bg-gradient-to-br from-[#fffdf5] to-white cursor-default flex sm:flex-col items-center sm:text-center gap-3.5 sm:gap-0" data-id="element-25">
                <div className="bg-green-light/10 w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center flex-shrink-0 sm:mb-3" data-id="element-26">
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-green" strokeWidth={1.75} data-id="element-27" />
                </div>
                <div className="text-left sm:text-center" data-id="element-28">
                  <span className="hidden sm:inline-block bg-green-light text-white text-[10px] sm:text-[11px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider mb-2.5" data-id="element-29">
                    Gratis
                  </span>
                  <h3 className="font-display text-sm sm:text-base font-bold text-navy mb-1 sm:mb-2 leading-snug" data-id="element-30">
                    {bono.title}
                  </h3>
                  <p className="text-[10px] sm:text-xs text-gray leading-relaxed" data-id="element-31">
                    {bono.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="text-center" data-id="element-32">
          <p className="text-sm sm:text-base text-gray" data-id="element-33">
            Valor total de los bonos:{' '}
            <strong className="text-green text-lg sm:text-xl" data-id="element-34">
              ¡GRATIS con tu compra!
            </strong>
          </p>
        </div>
      </div>
    </section>;
}